import SupportVideos from 'Vue/containers/SupportVideos.vue';
import { createApp } from "vue";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.supportVideosVueApp = function () {
	const sv = createApp(SupportVideos);
	sv.mount("#supportVideos");
};


module.init = function () {
	module.supportVideosVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
